import React from 'react';

const CarfaxUSIcon: React.FC = () => (
  <svg
    width="600"
    height="113"
    viewBox="0 0 600 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M577.1 101.5C577.1 106.3 573.1 110.1 568.3 110.1H11.3C6.4 110.1 2.5 106.2 2.5 101.5V11.1C2.5 6.30001 6.5 2.5 11.3 2.5H568.3C573.2 2.5 577.1 6.40001 577.1 11.1V101.5Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2 0C5 0 0 5 0 11V101.4C0 107.5 5 112.4 11.2 112.4H568.2C574.4 112.4 579.5 107.4 579.5 101.4V11C579.5 4.9 574.5 0 568.2 0H11.2ZM4.8 101.5V11.1C4.8 7.70001 7.7 4.90002 11.2 4.90002H568.2C571.8 4.90002 574.6 7.70001 574.6 11.1V101.5C574.6 104.9 571.7 107.7 568.2 107.7H11.2C7.7 107.7 4.8 104.9 4.8 101.5Z"
      fill="black"
    />
    <path d="M568.8 10.4H481.4V101.9H568.8V10.4Z" fill="white" />
    <path
      d="M480.2 103.1H570.1V9.20001H480.2V103.1ZM567.7 100.7H482.7V11.6H567.7V100.7Z"
      fill="black"
    />
    <path d="M192.6 10.6H105.1V102.1H192.6V10.6Z" fill="black" />
    <path
      d="M103.9 103.2H193.8V9.30005H103.9V103.2ZM191.4 100.8H106.4V11.7H191.4V100.8Z"
      fill="black"
    />
    <path d="M286.4 10.6H198.9V102.1H286.4V10.6Z" fill="black" />
    <path
      d="M197.7 103.2H287.6V9.30005H197.7V103.2ZM285.2 100.8H200.2V11.7H285.2V100.8Z"
      fill="black"
    />
    <path d="M380.7 10.6H293.3V102.1H380.7V10.6Z" fill="black" />
    <path
      d="M292.1 103.2H382V9.30005H292.1V103.2ZM379.5 100.8H294.5V11.7H379.5V100.8Z"
      fill="black"
    />
    <path d="M475.2 10.6H387.7V102.1H475.2V10.6Z" fill="black" />
    <path
      d="M386.5 103.2H476.4V9.30005H386.5V103.2ZM473.9 100.8H388.9V11.7H473.9V100.8Z"
      fill="black"
    />
    <path d="M98.1998 10.6H10.7998V102.1H98.1998V10.6Z" fill="black" />
    <path
      d="M9.6001 103.2H99.5001V9.30005H9.6001V103.2ZM97.0001 100.8H12.0001V11.7H97.0001V100.8Z"
      fill="black"
    />
    <path
      d="M56.6 89.2C38 89.2 28 75.4 28 56.8C28 36.6 39.8 24.4 56.7 24.4C72.1 24.4 78.2 31 82.5 42.9L66.7 49.1C64.5 43.3 62.3 39.6 56.6 39.6C49.3 39.6 46.2 46.9 46.2 56.8C46.2 66.4 49.2 74.1 56.8 74.1C62.3 74.1 64.6 71.1 68 65.2L82.7 73C78.4 81.3 71.4 89.2 56.6 89.2Z"
      fill="white"
    />
    <path
      d="M154.3 62.7H143.9L145.1 58.6C147.3 50.6 148.3 47.1001 149.1 42.9001C149.9 47.1001 150.9 50.5 153.1 58.6L154.3 62.7ZM180.7 87.5L157.9 24.8H140.3L117.5 87.5H136.1L139.5 76.4001H158.3L161.7 87.5H180.7Z"
      fill="white"
    />
    <path
      d="M251.4 46C251.4 50.5 249.2 53 243.5 53H233.3V39.3H243.8C249.3 39.3 251.4 42.1 251.4 46ZM270 87.8L257.4 63.9C264.3 60.8 268.7 55 268.7 45.5C268.7 30.6 258.9 25.1 244.2 25.1H216.1V87.8H233.2V66.7H240.2L250.4 87.9H270V87.8Z"
      fill="white"
    />
    <path d="M329.4 39.9V48.6H349.1V63.3H329.4V87.8H312.1V25.1H361.8V39.9H329.4Z" fill="white" />
    <path
      d="M436 63.2H425.6L426.8 59.1C429 51.1 430 47.6001 430.8 43.4001C431.6 47.6001 432.6 51 434.8 59.1L436 63.2ZM462.4 88L439.6 25.3H422.1L399.3 88H417.9L421.3 76.9001H440.1L443.5 88H462.4Z"
      fill="white"
    />
    <path
      d="M533.9 102.8L531.1 98.5C528.6 94.6 526.2 90.4 524.5 87C522.9 90.3 520.4 94.6 517.8 98.5L514.7 102.8H493.4L514 74.2L492.3 43.3H514.4L518.2 49.4001C520.6 53.3001 523.3 57.5 524.8 60.8C526.4 57.5 529 53.3001 531.5 49.4001L535.3 43.3H556.9L535.2 73.8L555.5 102.7H533.9V102.8Z"
      fill="black"
    />
    <path
      d="M599.8 8.80002C599.8 11.1 599 13.1 597.4 14.7C595.8 16.3 593.9 17.1 591.6 17.1C589.3 17.1 587.4 16.3 585.8 14.7C584.2 13.1 583.4 11.1 583.4 8.80002C583.4 6.40002 584.2 4.40002 585.8 2.80002C587.4 1.20002 589.3 0.400024 591.6 0.400024C593.9 0.400024 595.8 1.20002 597.4 2.80002C599 4.50002 599.8 6.50002 599.8 8.80002ZM598.5 8.80002C598.5 6.90002 597.8 5.20002 596.5 3.80002C595.2 2.40002 593.6 1.70001 591.7 1.70001C589.8 1.70001 588.1 2.40002 586.7 3.80002C585.3 5.20002 584.7 6.90002 584.7 8.90002C584.7 10.9 585.4 12.5 586.7 13.9C588.1 15.3 589.7 16 591.6 16C593.5 16 595.1 15.3 596.4 13.9C597.8 12.5 598.5 10.8 598.5 8.80002ZM596.2 6.60001C596.2 7.50001 595.9 8.30002 595.2 8.80002C594.6 9.30002 593.8 9.60001 593 9.60001L596 13.6H594.1L591.1 9.60001H589.4V13.6H587.9V3.70001H592.7C593.8 3.70001 594.6 4 595.2 4.5C596 5.1 596.2 5.80001 596.2 6.60001ZM594.7 6.60001C594.7 5.60001 593.9 5.10001 592.4 5.10001H589.5V8.30002H592.5C594 8.30002 594.7 7.80001 594.7 6.60001Z"
      fill="black"
    />
    <path
      d="M585.7 2.80005C584.1 4.50005 583.3 6.50006 583.3 8.90006C583.3 11.2001 584.1 13.3001 585.8 14.9001C587.4 16.5001 589.4 17.4001 591.7 17.4001C594 17.4001 596 16.6001 597.6 14.9001C599.2 13.2001 600 11.2001 600 8.90006C600 6.50006 599.2 4.50006 597.6 2.90006C596 1.20006 594 0.400057 591.7 0.400057C589.3 0.300057 587.3 1.10005 585.7 2.80005ZM586 14.6C584.4 13 583.6 11.1001 583.6 8.80005C583.6 6.50005 584.4 4.50006 585.9 2.90006C587.5 1.30006 589.4 0.500033 591.6 0.500033C593.8 0.500033 595.7 1.30006 597.3 2.90006C598.9 4.50006 599.6 6.50004 599.6 8.70004C599.6 11 598.8 12.9 597.3 14.5C595.7 16.1 593.8 16.9001 591.6 16.9001C589.5 17.0001 587.5 16.2 586 14.6Z"
      fill="black"
    />
    <path
      d="M586.7 3.70001C585.3 5.10001 584.6 6.90002 584.6 8.90002C584.6 10.9 585.3 12.6 586.7 14C588.1 15.4 589.8 16.1 591.7 16.1C593.6 16.1 595.3 15.4 596.6 13.9C598 12.5 598.7 10.7 598.7 8.80002C598.7 6.80002 598 5.10001 596.6 3.70001C595.2 2.30001 593.6 1.5 591.7 1.5C589.8 1.5 588.1 2.20001 586.7 3.70001ZM586.9 13.8C585.6 12.4 584.9 10.8 584.9 8.90002C584.9 7.00002 585.6 5.30002 586.9 3.90002C588.2 2.50002 589.9 1.80002 591.7 1.80002C593.5 1.80002 595 2.50002 596.4 3.90002C597.7 5.30002 598.4 6.90002 598.4 8.80002C598.4 10.7 597.7 12.4 596.4 13.8C595.1 15.2 593.5 15.9 591.7 15.9C589.8 15.8 588.2 15.1 586.9 13.8Z"
      fill="black"
    />
    <path
      d="M587.9 3.59998V13.8H589.7V9.79999H591.3L594.2 13.7L596.2 13.8H596.5C596.5 13.8 593.7 10.1 593.5 9.79999C594.3 9.69999 595 9.49997 595.6 8.99997C596.3 8.39997 596.6 7.59998 596.6 6.69998C596.6 5.79998 596.3 5.09997 595.7 4.49997C595.1 3.89997 594.2 3.59998 593.1 3.59998H587.9ZM592.9 3.89999C593.9 3.89999 594.7 4.19998 595.3 4.69998C595.8 5.19998 596.1 5.89998 596.1 6.69998C596.1 7.59998 595.8 8.29999 595.2 8.79999C594.6 9.29999 593.9 9.59998 593.1 9.59998H592.8C592.8 9.59998 595.5 13.2 595.8 13.6H594.2L591.3 9.69998L589.5 9.59998H589.4V13.6H588.2V3.99997H592.9V3.89999Z"
      fill="black"
    />
    <path
      d="M589.4 5V8.5H592.5C594 8.5 594.8 7.90001 594.8 6.60001C594.8 6.00001 594.6 5.60002 594.2 5.40002C593.8 5.10002 593.2 5 592.4 5H589.4ZM592.4 5.30002C593.1 5.30002 593.7 5.40001 594 5.60001C594.3 5.80001 594.5 6.20001 594.5 6.60001C594.5 7.70001 593.8 8.20001 592.5 8.20001H589.6V5.30002H592.4Z"
      fill="black"
    />
  </svg>
);

export default CarfaxUSIcon;
